import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import GeneralContainer from '../components/GeneralContainer'

export default function N25_11_12() {
  return (
    <NoteContainer date={'12/11/2025'} version="20.20.3">
      <VStack w="full">
        <GeneralContainer>
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Notificações</TaskTitle>
                <TaskBreadcrumb>Geral</TaskBreadcrumb>
                <TaskDescription>
                  Corrigido o problema que impossibilitava a visualização das notificações, que em sua maioria, eram em
                  casos de erros na plataforma
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </GeneralContainer>
      </VStack>
    </NoteContainer>
  )
}
